import { Trans } from "@lingui/macro";
import { IPeriodUnit } from "@smp/api";
import { UiBox, UiTypography } from "@smp/ui";
import { textCurrencySymbolGet } from "@smp/utils";
import { FC, useMemo } from "react";

import { useHumanizer } from "@/hooks/use_humanizer";

import { IProductDescriptionProps } from "../../product_description";

export const PlanProductAdditions: FC<{
  product: Extract<
    IProductDescriptionProps["product"],
    { type: "plan-product" }
  >;
  paymentType: IProductDescriptionProps["paymentType"];
}> = ({ product, paymentType }) => {
  const { humanizeBillingPlanId, humanizePeriodUnit } = useHumanizer();

  const period = useMemo(
    () =>
      product.period_units === IPeriodUnit.DAY && product.period_length === 1
        ? humanizePeriodUnit(IPeriodUnit.HOUR, product.period_length * 24)
        : humanizePeriodUnit(product.period_units, product.period_length),
    [humanizePeriodUnit, product.period_length, product.period_units],
  );

  return (
    <UiBox mb={2}>
      <UiTypography color="textSecondary" variant="subtitle2">
        {paymentType === "recurring" && (
          <Trans>
            The {humanizeBillingPlanId(product.plan.id)} Plan subscription will
            be activated for {period}
            .
            <br />
            Total payment: {product.price}{" "}
            {textCurrencySymbolGet(product.currency)}.
          </Trans>
        )}
        {paymentType === "single" && (
          <Trans>
            The {humanizeBillingPlanId(product.plan.id)} Plan will be activated
            for {period}
            .
            <br />
            Total payment: {product.price}{" "}
            {textCurrencySymbolGet(product.currency)}.
          </Trans>
        )}
      </UiTypography>
    </UiBox>
  );
};
